import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: auto;
    gap: 20px;
`;

export const SearchContainer = styled.div`
    width: fit-content;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
`;

export const BalanceContainer = styled.div`
    width: fit-content;
    white-space: nowrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
`;
